<template>
  <b-row align-h="center">
    <div class="paginate d-inline-flex justify-content-between align-items-center">
      <p class="paginate_text small d-inline-block mt-0">
        Página
      </p>

      <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
              :class="{ 'inactive': (Number(page) === 1) }"
              :disabled="(Number(page) === 1)"
              type="button"
              title="Página anterior"
              @click="previous">
        <svg class="paginate_icon icon--xxs"
             role="presentation">
          <use :xlink:href="'#' + arrow_left.id" />
        </svg>
      </button>

      <p v-if="!selectPage"
         class="paginate_text small d-inline-block mt-0">
        {{ page }}
      </p>
      <div v-if="selectPage"
           style="width: auto">
        <select v-model="pageAtual"
                class="form-control form-control-sm"
                @change="(page) => setPage(page)">
          <option v-for="(value, index) in lastPage"
                  :key="`option_paginate_dashboard_${ index }_${ _uid }`"
                  :value="value">
            {{ value }}
          </option>
        </select>
      </div>


      <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
              :class="{ 'inactive': page === lastPage || lastPage == 0 }"
              :disabled="(page === lastPage || lastPage == 0)"
              type="button"
              title="Próxima página"
              @click="next">
        <svg class="paginate_icon icon--xxs"
             role="presentation">
          <use :xlink:href="'#' + arrow_right.id" />
        </svg>
      </button>

      <p class="paginate_text small d-inline-block mt-0">
        {{ `de ${lastPage}` }}
      </p>
    </div>
  </b-row>
</template>

<script>
  import arrow_left from '@/assets/icons/arrow-left.svg?sprite'
  import arrow_right from '@/assets/icons/arrow-right.svg?sprite'

  export default {
    name: "Pagination",
    props: ["page", "lastPage", "selectPage"],
    data () {
      return {
        arrow_left,
        arrow_right,
        pageAtual: 1
      }
    },
    watch: {
      page () {
        this.pageAtual = this.page
      }
    },
    created () {
      this.pageAtual = this.page || 1
    },
    methods: {
      previous () {
        this.$emit('onPreviousPage')
      },
      next () {
        this.$emit('onNextPage')
      },
      setPage () {
        this.$emit('onSetPage', this.pageAtual)
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/exports';

  .resultsOpt {
    border-top: pxToRem(1) solid $color-blue;
  }

  .paginate {
    &_text {
      font-size: pxToRem(14);
      font-weight: 500;
      margin-bottom: 0;
    }

    &_icon {}

    &_btn {
      &.inactive {
        .paginate_icon {
          fill: $color-gray;
        }
      }
    }
  }

  .ordenateBox {}
</style>
